import { ApiErrorCode } from "config";

export type MaintenanceApiResponseData = {
  code?: string;
  status?: string;
};

export function isMaintenanceApiResponse(
  statusCode: number | undefined,
  responseData: MaintenanceApiResponseData | undefined
): boolean {
  return (
    statusCode === 503 &&
    (responseData?.code === ApiErrorCode.MAINTENANCE || responseData?.status === "maintenance")
  );
}
